<!-- todo: add buttons to set interval time up and down -->
<template>
  <div v-cloak>
    <div style="box-sizing:border-box;width:100%;height:100%;padding:1vw">      
      <p class="h2">{{ program.name }}</p>

      <div class="flex justify-content-center">
        <svg class="pointer" style="width:6vw;height:6vw;vertical-align:middle" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="48" stroke-linecap="round" stroke-linejoin="round" @click="previous"><polyline points="336,112 176,256 336,400"/></svg>
        <svg class="pointer" style="width:6vw;height:6vw;vertical-align:middle" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="48" stroke-linecap="round" stroke-linejoin="round" @click="next"><polyline points="176,112 336,256 176,400"/></svg>
      </div>


      <div class="flex justify-content-center" style="margin-top:3vw">
        <span class="h2">{{ duration }}</span>
        <svg style="width:6vw;height:6vw;margin-left:2vw;vertical-align:middle" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="48" stroke-linecap="round" stroke-linejoin="round" @click="down"><polyline points="112,176 256,336 400,176"/></svg>
        <svg style="width:6vw;height:6vw;vertical-align:middle" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="48" stroke-linecap="round" stroke-linejoin="round" @click="up"><polyline points="112,336 256,176 400,336"/></svg>
      </div>
      
    </div>
  </div>
</template>


<script>
  export default {
    name: 'programSetup',
    emits:["previous","next","up","down"],
    props: {
      selectedProgram:Number,
      programs:Array,
    },
    data() {
      return {
      }
    },
    methods: {
      previous() {
        this.$emit("previous");
      },
      next() {
        this.$emit("next");
      },
      up() {
        // todo: select hour or minute (defaults to minute)
        this.$emit("up");
      },
      down() {
        this.$emit("down");
      },
      timeDisplay(timeSeconds) {
        const hours = Math.floor(timeSeconds / 3600);
        const secondsRemaining = timeSeconds%3600;
        const minutes = Math.floor(secondsRemaining / 60);
        const seconds = secondsRemaining % 60;
        
        const tHours = hours<10?"0"+hours:hours;
        const tMinutes = minutes<10?"0"+minutes:minutes;
        const tSeconds = seconds<10?"0"+seconds:seconds;

        return tHours + ":" + tMinutes + ":" + tSeconds;
      },
    },
    computed: {
      program() {
        return this.programs[this.selectedProgram];
      },
      
      duration() {
        return this.timeDisplay(this.program.time);
      }
    },
    watch: {  
    },
    mounted() {
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .option {
    font-size:7vw;
    line-height:9vw;
  }

  p {
    margin-top:0.5vw;
    margin-bottom:0.5vw;
  }
</style>
